//@flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo
import type { FpVisitAddressModelType } from './FpVisitAddress';

export type FpVisitTypeEnum = 'WAREHOUSE' | 'SUPPLIER' | 'CLIENT';

export type FpOutletVisitModelType = {
    id: string,
    sourceOutletId: string,
    zoneId: string,
    category: string,
    visitType: FpVisitTypeEnum,
    address: FpVisitAddressModelType,
    revenue: {
        amount: number,
        currency: ?string,
        symbol: ?string
    },
    possibleDays: Array<FpVisitDaysModelType>,
    volume: number
};

export type FpVisitDaysModelType = {
    days: Array<string>,
    week: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class FpOutletVisit extends ImmutableModel {
    static fromJS(json: FpOutletVisitModelType): FpOutletVisit {
        const state: Object = Object.assign({}, json);
        state.address = FpVisitAddress.fromJS(state.address);
        state.possibleDays = Immutable.List(state.possibleDays).map(item =>
            FpVisitDays.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): FpOutletVisitModelType {
        return {
            id: this.id,
            sourceOutletId: this.sourceOutletId,
            zoneId: this.zoneId,
            category: this.category,
            visitType: this.visitType,
            address: this.address.toJS(),
            revenue: this.revenue,
            possibleDays: this.possibleDays.toArray().map(item => item.toJS()),
            volume: this.volume
        };
    }

    get id(): string {
        return this._state.get('id');
    }

    setId(id: string): this {
        return this.clone(this._state.set('id', id));
    }

    get sourceOutletId(): string {
        return this._state.get('sourceOutletId');
    }

    setSourceOutletId(sourceOutletId: string): this {
        return this.clone(this._state.set('sourceOutletId', sourceOutletId));
    }

    get zoneId(): string {
        return this._state.get('zoneId');
    }

    setZoneId(zoneId: string): this {
        return this.clone(this._state.set('zoneId', zoneId));
    }

    get category(): string {
        return this._state.get('category');
    }

    setCategory(category: string): this {
        return this.clone(this._state.set('category', category));
    }

    get visitType(): FpVisitTypeEnum {
        return this._state.get('visitType');
    }

    setVisitType(visitType: FpVisitTypeEnum): this {
        return this.clone(this._state.set('visitType', visitType));
    }

    get address(): FpVisitAddress {
        return this._state.get('address');
    }

    setAddress(address: FpVisitAddress): this {
        return this.clone(this._state.set('address', address));
    }

    get revenue(): {
        amount: number,
        currency: ?string,
        symbol: ?string
    } {
        return this._state.get('revenue');
    }

    setRevenue(revenue: {
        amount: number,
        currency: ?string,
        symbol: ?string
    }): this {
        return this.clone(this._state.set('revenue', revenue));
    }

    get possibleDays(): Immutable.List<FpVisitDays> {
        return this._state.get('possibleDays');
    }

    setPossibleDays(possibleDays: Immutable.List<FpVisitDays>): this {
        return this.clone(this._state.set('possibleDays', possibleDays));
    }

    get volume(): number {
        return this._state.get('volume');
    }

    setVolume(volume: number): this {
        return this.clone(this._state.set('volume', volume));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class FpVisitDays extends ImmutableModel {
    static fromJS(json: FpVisitDaysModelType): FpVisitDays {
        const state: Object = Object.assign({}, json);
        state.days = Immutable.List(state.days);
        return new this(Immutable.Map(state));
    }

    toJS(): FpVisitDaysModelType {
        return {
            days: this.days.toArray(),
            week: this.week
        };
    }

    get days(): Immutable.List<string> {
        return this._state.get('days');
    }

    setDays(days: Immutable.List<string>): this {
        return this.clone(this._state.set('days', days));
    }

    get week(): string {
        return this._state.get('week');
    }

    setWeek(week: string): this {
        return this.clone(this._state.set('week', week));
    }
}
